// no-cache to avoid fetch issues from AWS S3 bucket
export const S3_FETCH_OPTIONS = {
  cache: 'no-cache',
  headers: {
    Origin: window.location.origin,
  },
  method: 'GET',
  mode: 'cors',
}

// The always-loaded FamilySearch app fonts that every design starts with (see useReady). Designs
// with their own typography push additional families on top of these. Custom-font designs need
// html2canvas's manual DOM renderer for reliable @font-face output; base-only designs render
// correctly via foreignObject, so this set is how the two are told apart when picking a mode.
export const BASE_KEEP_FONTS = ['museo', 'noto serif tc']

export const KEEP_PROCESS_TYPE = {
  DOWNLOAD: 'download',
  PRINT: 'print',
  SHARE: 'share',
}

// Supported rendering formats in millimeters
// https://stackoverflow.com/questions/3503615/what-are-the-minimum-margins-most-printers-can-handle
export const PAGE_SIZES = {
  // https://papersdb.com/a/a4
  a4: {
    longEdge: 297,
    shortEdge: 210,
    printMargin: 6,
  },
  // https://papersdb.com/miscellaneous/a4-square
  a4Square: {
    longEdge: 210,
    shortEdge: 210,
    printMargin: 5,
  },
  // https://papersdb.com/us/letter
  letter: {
    longEdge: 279,
    shortEdge: 216,
    printMargin: 6.35,
  },
}
